"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _usePonyfill = _interopRequireDefault(require("../providers/Ponyfill/usePonyfill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _usePonyfill.default;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VQb255ZmlsbCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVBvbnlmaWxsLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VQb255ZmlsbCBmcm9tICcuLi9wcm92aWRlcnMvUG9ueWZpbGwvdXNlUG9ueWZpbGwnO1xuXG5leHBvcnQgZGVmYXVsdCB1c2VQb255ZmlsbDtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O2VBRWVBLG9CIn0=